import { useOrderConditionContext } from '../../../../../../../contexts/OrderCondition.context';
import { OrderConditionNavigatorStepConfig } from '../orderConditionNavigator.types';

interface UseOrderConditionNavigatorParams {
  currentConditionId: string;
}

interface UseOrderConditionNavigatorResult {
  previous: OrderConditionNavigatorStepConfig;
  next: OrderConditionNavigatorStepConfig;
}

const useOrderConditionNavigator = ({
  currentConditionId,
}: UseOrderConditionNavigatorParams): UseOrderConditionNavigatorResult => {
  const { orderConditions, selectCondition } = useOrderConditionContext();

  const currentIndex = orderConditions.findIndex(
    (condition) => condition.id === currentConditionId,
  );

  const previousCondition = currentIndex > 0 ? orderConditions[currentIndex - 1] : undefined;
  const nextCondition = currentIndex >= 0 ? orderConditions[currentIndex + 1] : undefined;

  return {
    previous: {
      isDisabled: !previousCondition,
      onClick: () => previousCondition && selectCondition(previousCondition.id),
    },
    next: {
      isDisabled: !nextCondition,
      onClick: () => nextCondition && selectCondition(nextCondition.id),
    },
  };
};

export default useOrderConditionNavigator;
